import { render, staticRenderFns } from "./v-gridform-field-list.vue?vue&type=template&id=52f57fe8&scoped=true&"
import script from "./v-gridform-field-list.vue?vue&type=script&lang=js&"
export * from "./v-gridform-field-list.vue?vue&type=script&lang=js&"
import style0 from "./v-gridform-field-list.vue?vue&type=style&index=0&id=52f57fe8&lang=scss&scoped=true&"
import style1 from "./v-gridform-field-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f57fe8",
  null
  
)

export default component.exports